/* Little Teekies — global helpers (lt-theme.js)
   - Flags <html> with .lt-js so CSS may hide .lt-reveal elements until observed
   - Reveal-on-scroll via IntersectionObserver (adds .is-visible, staggered via --lt-delay)
   - Re-scans when Shopify theme editor loads/reorders sections
   No dependencies. Safe to include more than once (guarded). */
(function () {
  'use strict';
  if (window.__ltThemeInit) return;
  window.__ltThemeInit = true;

  var root = document.documentElement;
  root.classList.add('lt-js');

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var observer = null;
  var supportsIO = 'IntersectionObserver' in window;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function stagger(el) {
    // Give siblings inside the same parent a stepped delay unless one is set inline.
    if (el.style.getPropertyValue('--lt-delay')) return;
    var parent = el.parentElement;
    if (!parent) return;
    var siblings = parent.querySelectorAll(':scope > .lt-reveal');
    if (siblings.length < 2) return;
    var index = Array.prototype.indexOf.call(siblings, el);
    if (index > 0) el.style.setProperty('--lt-delay', Math.min(index, 8) * 80 + 'ms');
  }

  function observe(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var nodes = context.querySelectorAll('.lt-reveal:not(.is-visible)');
    if (!nodes.length) return;

    if (!supportsIO || reduceMotion) {
      Array.prototype.forEach.call(nodes, reveal);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }

    Array.prototype.forEach.call(nodes, function (el) {
      try { stagger(el); } catch (e) {}
      // Anything already in the viewport at load reveals immediately (no jank above the fold).
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        reveal(el);
        return;
      }
      observer.observe(el);
    });
  }

  function init() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: sections are re-rendered in place; make sure nothing is stuck hidden.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target && e.target.closest ? e.target.closest('.shopify-section') : null;
    if (section) {
      Array.prototype.forEach.call(section.querySelectorAll('.lt-reveal'), reveal);
    }
  });

  // Safety net: if for any reason observation never fires, nothing stays invisible.
  window.setTimeout(function () {
    Array.prototype.forEach.call(document.querySelectorAll('.lt-reveal:not(.is-visible)'), function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 1.2) reveal(el);
    });
  }, 2500);

  window.ltReveal = { observe: observe, reveal: reveal };
})();
